import React from 'react';

import DropZone from 'components/Pages/FileLibrary/Common/DropZone';
import Context from 'components/Pages/FileLibrary/context';

import { DROP_ZONE_PLACEHOLDER, ALLOWED_MIME_TYPES } from '../constants';

const Uploader = ({ onUpload }) => (
  <Context.Provider
    value={{
      placeholder: DROP_ZONE_PLACEHOLDER,
      onSelectNewFiles: onUpload,
      allowedMimeTypes: ALLOWED_MIME_TYPES,
      maxFileSize: 10,
      maxImageWidth: 1200,
      maxImageHeight: 1200,
      renderFilePropertiesHint: () => 'Please make sure your logo is less than 1200px x 1200px',
    }}
  >
    <DropZone />
  </Context.Provider>
);

export default Uploader;
